
export const WEBSERVICE_ERRORS = {
  PRODUCT_REGISTERED: 'TCOL-VENTAS-013',
  INCOMPATIBLE_PRODUCT_2: 'TCOL-VENTAS-106',
  INCOMPATIBLE_PRODUCT: 'TCOL-VENTAS-008-3',
  TV_PRODUCT_REGISTERED: 'TCOL-VENTAS-008-6',
  PRODUCT_WITHOUT_AVAILABLE_ACTIONS: 'TCOL-VENTAS-008-29',
  MIMOVISTAR_CUSTOMER_ORDER_IN_PROGRESSS: 'TCOL-VENTAS-008-39',
  CUSTOMER_QUOTE_IN_PROGRESS: 'TCOL-VENTAS-008-2',
  CUSTOMER_ORDER_IN_PROGRESS: 'TCOL-VENTAS-008-5',
  CUSTOMER_QUOTE_NOT_CANCELABLE: 'TCOL-VENTAS-016',
  MAX_CARDINALITY_REACHED: 'TCOL-VENTAS-008-7',
  ROUTER_WIFI_6_NEEDED: 'TCOL-VENTAS-008-48',
  INCOMPATIBLE_PRODUCT_CONTRATO_L: 'CONT-E-003472',
  DOBLE_PORTABILITY_RESERVATION: 'CONT-E-002433',
  INCOMPATIBLE_PRODUCT_BY_ZONE: 'CONT-E-003711',
  NOT_ACTIVATABLE_LINES: 'CONT-E-002930',
  INVALID_CONTACTS: 'GCLI-E-030116',
  INVALID_EMAIL: 'GCLI-E-000358',
  ACCOUNT_WITH_RISK: 'CONT-E-003407',
  CLIENT_WITH_DEBT: 'TCOL-VENTAS-020-400',
  CLIENT_RISK_ECONOMIC_DOC_NEEDED: 'TCOL-VENTAS-020-420',
  RISK_VALIDATION_UNAVAILABLE: 'TCOL-VENTAS-020-667',
  CLIENT_WITH_RISK: 'TCOL-VENTAS-020-800',
  INSUFFICIENT_CREDIT_LIMIT: 'TCOL-VENTAS-020-840',
  MAX_R2R_REACHED: 'TCOL-VENTAS-020-850',
  ONBOARDING_NEEDED: 'TCOL-VENTAS-020-860',
  CLIENT_RISK_VALIDATION: 'TCOL-VENTAS-020-921',
  CLIENT_RISK_DOC_NEEDED: 'TCOL-VENTAS-020-931',
  RISK_VALIDATION_TEMPORALLY_UNAVAILABLE: 'TCOL-VENTAS-020-998',
  NO_HIRED_PRODUCTS_TO_BUY: 'TCOL-VENTAS-078',
  WITHOUT_COVERAGE: 'CONT-E-002814',
  WITHOUT_COVERAGE_ADDRESS: 'CONT-E-002322',
  LOW_SENIORITY_R2R: 'TCOL-VENTAS-101',
  WITHOUT_DEPENDENT_OFFER: 'CONT-E-002818',
  OFFER_WITH_SOME_DEPENDENCIES: 'CONT-E-003450',
  INCORRECT_BISI_CHARS: 'CONT-E-003277',
  INCORRECT_PRODUCT_OFFERING_STATE: 'CATA-E-000901',
  OTP_EXPIRED: 'TCOL-VENTAS-085',
  OTP_INCORRECT: 'TCOL-VENTAS-086',
  PORTABILITY_OTP_INCORRECT: 'TCOL-VENTAS-007',
  OTP_INVALID: 'SEGU-E-000001',
  OTP_MAX_RETRIES_REACHED: 'TCOL-VENTAS-087',
  WITHOUT_POSSIBLE_ACTIONS: 'TCOL-VENTAS-003',
};
